import { useState, useCallback, useRef, useEffect } from 'react'

import { obtenerImagenesPublicacion } from '../helpers/obtenerImagenesPublicacion.js'

export const useImagenesPublicacion = () => {
  const [adjuntos, setAdjuntos] = useState([])
  const [loadingImagenes, setLoadingImagenes] = useState(false)
  const prevUrlsRef = useRef([])

  useEffect(() => {
    const prevUrls = prevUrlsRef.current
    prevUrls.forEach((prev) => {
      const exists = adjuntos.some((curr) => curr.url === prev.url)
      if (!exists) {
        URL.revokeObjectURL(prev.url)
      }
    })
    prevUrlsRef.current = adjuntos
  }, [adjuntos])

  // Limpieza al desmontar
  useEffect(() => {
    return () => {
      prevUrlsRef.current.forEach(({ url }) => URL.revokeObjectURL(url))
    }
  }, [])

  const fetchImagenes = useCallback(
    async ({
      idPublicaciones,
      idPublicacionTemporal,
      idUsuario,
      tieneFotoDefault,
      soloImagenPrincipal
    } = {}) => {
      setLoadingImagenes(true)

      try {
        await obtenerImagenesPublicacion({
          idPublicaciones,
          idPublicacionTemporal,
          idUsuario,
          setAdjuntos,
          tieneFotoDefault,
          soloImagenPrincipal
        })
      } finally {
        setLoadingImagenes(false)
      }
    },
    []
  )

  return { adjuntos, setAdjuntos, loadingImagenes, fetchImagenes }
}
